import * as Yup from "yup";

export const schema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  dayType: Yup.string().required("Day type is required"),
  startTime: Yup.string().required("Start time is required"),
  endTime: Yup.string().required("End time is required"),
  rules: Yup.array().of(Yup.string().required("Rule is required")),
  important: Yup.array().of(Yup.string().required("Important is required")),
  pitchTypeId: Yup.mixed().required("Pitch type ID is required"),
  pitch: Yup.array().min(1, "Pitch name is required"),
  gameType: Yup.array().min(1, "Game type is required"),
  individualGame: Yup.object().shape({
    targetMargin: Yup.number().required("Target margin is required"),
    price: Yup.number().required("Actual revenue is required"),
    costOfPitch: Yup.number().required("Cost of pitch is required"),
    hostCommission: Yup.number().required("Host commission is required"),
  }),
  fullPitchBooking: Yup.object().shape({
    price: Yup.number().required("Price is required"),
    costOfPitch: Yup.number().required("Cost of pitch is required"),
    profitMargin: Yup.number().required("Profit margin is required"),
    depositPrice: Yup.number().required("Deposit Price is required"),
  }),
  friendlyGame: Yup.object().shape({
    price: Yup.number().required("Price is required"),
    costOfPitch: Yup.number().required("Cost of pitch is required"),
    profitMargin: Yup.number().required("Profit margin is required"),
  }),
});
